<template>
  <div class="error404" style="margin-bottom:150px;">
    <h1>404</h1>
    <h2>OH NO!</h2>
    <h3>Something went missing!</h3>
  </div>
</template>
<script>
export default {
  title: 'Patronus Records - 404'
}
</script>

<style scoped>
  .error404 {
    padding-top:120px;
    widows: 100%;
    height: 100%;
    text-align: center;
    text-shadow: 0 8px 10px rgba(0, 0, 0, 0.5);
  }
  h1 {font-size: 122px;}
  h2 {font-size: 72px;}
  h3 {text-transform: uppercase; letter-spacing: 1px;}
</style>



// WEBPACK FOOTER //
// src/pages/404.vue